@import "../skeleton/skeleton.scss";

:host {
    --wcs-skeleton-text-height: var(--wcs-semantic-font-size-base);
    --wcs-skeleton-text-height-h1: var(--wcs-semantic-font-size-heading-1);
    --wcs-skeleton-text-height-h2: var(--wcs-semantic-font-size-heading-2);
    --wcs-skeleton-text-height-h3: var(--wcs-semantic-font-size-heading-3);
    --wcs-skeleton-text-height-body: var(--wcs-semantic-font-size-body-3);
    --wcs-skeleton-text-height-caption: var(--wcs-semantic-font-size-caption-1);
}

:host([height=h1]) {
    height: var(--wcs-skeleton-text-height-h1);
}

:host([height=h2]) {
    height: var(--wcs-skeleton-text-height-h2);
}

:host([height=h3]) {
    height: var(--wcs-skeleton-text-height-h3);
}

:host([height=body]) {
    height: var(--wcs-skeleton-text-height-body);
}

:host([height=caption]) {
    height: var(--wcs-skeleton-text-height-caption);
}
